import { http } from "./http";

export const keysApi = {
  list() {
    return http.get("/api/admin/keys/list").then((r) => r.data);
  },

  online() {
    return http.get("/api/admin/keys/online").then((r) => r.data);
  },

  generate({
    count = 1,
    mode = "expire_at",
    days = null,
    hours = null,
    note = null,
  }) {
    return http
      .post("/api/admin/keys/generate", { count, mode, days, hours, note })
      .then((r) => r.data);
  },

  disable({ key, reason }) {
    return http
      .post("/api/admin/keys/disable", { key, reason })
      .then((r) => r.data);
  },

  enable({ key }) {
    return http.post("/api/admin/keys/enable", { key }).then((r) => r.data);
  },

  extend({ key, days = null, hours = null }) {
    return http
      .post("/api/admin/keys/extend", { key, days, hours })
      .then((r) => r.data);
  },

  deleteKey({ key }) {
    return http.post("/api/admin/keys/delete", { key }).then((r) => r.data);
  },
};
